import * as angular from 'angular';

import { ApprovalSettings } from '../../models';
import { IDispatcherService, IDispatcher, IApprovalSettingActionsService } from '..';

export interface IApprovalSettingsStoreService {
    create(strategy: ApprovalSettings): angular.IPromise<ApprovalSettings[]>;
    update(strategy: ApprovalSettings): angular.IPromise<ApprovalSettings[]>;
    getOne(guid: string): angular.IPromise<ApprovalSettings>;
    getAll(): angular.IPromise<ApprovalSettings[]>;
    getAll(force: boolean): angular.IPromise<ApprovalSettings[]>;
}

export interface IApprovalSettingsActionsDispatcherService extends IDispatcherService<IApprovalSettingsStoreService> { }

export class ApprovalSettingsActionsDispatcherService implements IApprovalSettingsActionsDispatcherService {
    static serviceId = 'approvalSettingsActionsDispatcherService';

    static $inject = ['approvalSettingsActionsService'];

    constructor(private _actionService: IApprovalSettingActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IApprovalSettingsStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(actionService.getOne(guid)),
                getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
                create: (settings: ApprovalSettings) => dispatch(actionService.addOne(settings)),
                update: (settings: ApprovalSettings) => dispatch(actionService.updateOne(settings)),
            }
        };
    }
}